import React from 'react'
import { Navigate } from 'react-router-dom'

function PrivateRoute({ user, children, onLogout }) {
  if (!user) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default PrivateRoute
